<template>
    <div class="content">
      <LoginLogo />

        <v-container>
            <v-row class="justify-center">
                {{$t('routes.disabled.disabledMessage')}}
            </v-row>
            <v-row>
                <v-btn
                    type="button"
                    class="bg-primary mt-6"
                    block
                    data-cy=""
                    to="/account/logout"
                >
                {{$t('routes.disabled.logout')}}
                </v-btn>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: "ForcedLogout",
  components: {
    LoginLogo,
  },
  // data: function() {
  //   return {
  //   };
  // },
  methods: {
    redirect: async function() {
      this.$router.push('/account/logout');
    }
  },
}
</script>

<style>

</style>
